/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import set from 'lodash/set';
import unset from 'lodash/unset';
import * as types from '../constants';
import { cloneState } from '../utils/stateUtils';

const INITIALSTATE = {
    summary: [],
};

export default function validationReducer(state = INITIALSTATE, action) {
    let st = { ...state };

    switch (action.type) {
        case types.SET_VALIDATION_ERROR:
            st = cloneState(state);
            const { path, error } = action.payload;

            if (action.payload.error) {
                set(st, path, error);
                st.summary = [
                    ...st.summary.filter((err) => err.path !== path),
                    { path, error },
                ];
            } else {
                unset(st, action.payload.path, action.payload.error);
                st.summary = [...st.summary.filter((err) => err.path !== path)];
            }
            return st;
        default:
            return st;
    }
}
